import { render, staticRenderFns } from "./AnswerQuestions.vue?vue&type=template&id=27ba5c89&"
import script from "./AnswerQuestions.vue?vue&type=script&lang=js&"
export * from "./AnswerQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports